// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-green {\n  font-weight: bold;\n  color: green;\n}\n.text-error {\n  font-weight: bold;\n  color: red;\n}\n.text-gray {\n  color: gray;\n}", ""]);
// Exports
module.exports = exports;
